import * as React from "react";
import { LayoutProvider } from "./src/context/layoutContext";

export const wrapPageElement = ({ element }) => {
	// Esta movida permite meter elementos como children del contexto de i18next, para poder usar traducciones en Context components de todas las páginas
	const newElement = React.cloneElement(
		element, // I18nextProvider
		element.props,
		React.cloneElement(
			element.props.children, // I18nextContext.Provider
			element.props.children.props,
			<LayoutProvider>{element.props.children.props.children}</LayoutProvider>,
		),
	);

	return newElement;
};
